import { commitEdit, type CommitEditCtx } from '../commitEdit';

/**
 * Reorder a GROUP BY item from `fromIndex` to `toIndex` (arrayMove semantics).
 * Commits a single `reorder-group-by` structural edit — the same byte-splice
 * `planListMove` planner `move-select-item` uses (see
 * applyStructuralEdit.move.ts), applied over `structure.groupBy` instead of
 * `structure.selectItems`.
 *
 * No-op when indices are non-integer, negative, or equal — the resolver
 * planner guards too (including a comma-count shape-mismatch bail), but
 * short-circuiting avoids an empty commit round-trip. Mirrors `reorderColumns`.
 */
export async function reorderGroupBy(
  fromIndex: number,
  toIndex: number,
  ctx: CommitEditCtx,
): Promise<void> {
  if (
    !Number.isInteger(fromIndex) ||
    !Number.isInteger(toIndex) ||
    fromIndex < 0 ||
    toIndex < 0 ||
    fromIndex === toIndex
  ) {
    return;
  }
  await commitEdit({ op: 'reorder-group-by', fromIndex, toIndex }, ctx);
}
